app.controller("FreshStudentExamsRequestReseatController", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "$state", "toastr", "StudentExamsService",
    function ($scope, ExamsManagerService, $uibModalInstance, $state, toastr, StudentExamsService) {

        $scope.chosenSubject = null;
        $scope.chosenSession = null;
        $scope.subjects = [];
        $scope.sessions = [];

        $scope.edit = function () {
            if(!$scope.chosenSubject) {
                return toastr.warning("გთხოვთ აირჩიოთ საგანი");
            }
            if(!$scope.chosenSession) {
                return toastr.warning("გთხოვთ აირჩიოთ სესია");
            }

            return StudentExamsService.requestReseat({
                subjectId: $scope.chosenSubject.subject._id,
                subjectSelectionId: $scope.chosenSubject._id,
                examSessionId: $scope.chosenSession
            })
                .then(function (data) {
                    if (data.status === "success") {
                        toastr.success("გადაბარების მოთხოვნა გაგზავნილია");
                        $uibModalInstance.close();
                    } else {
                        toastr.warning("გთხოვთ ცადოთ სხვა სესია");
                    }
                });
        };


        $scope.getSessionsForStudentWithFreeSeats = function () {
            console.log($scope.chosenSubject);
            return StudentExamsService.getSessionsWithFreeSeatsBySubject({chosenSubject: $scope.chosenSubject.subject._id})
                .then(function (data) {
                    $scope.sessions = data;
                });
        };


        $scope.getAvailableSubjects = function () {
            return StudentExamsService.getAvailableSubjects()
                .then(function (data) {
                    $scope.subjects = data;
                });
        };

        $scope.getAvailableSubjects();


        $scope.seatChanged = function () {
            // console.log($scope.chosenSeat);
            // console.log($scope.chosenSession);
            // console.log($scope.chosenSession.examHall.withComputers);
        };


        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);
